import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export function useCaptionPresets() {
  return useQuery<Record<string, string[]>>({
    queryKey: ['caption-presets'],
    queryFn: () => api.get('/poster/caption-presets'),
    staleTime: 10 * 60 * 1000,
  })
}

export function useSaveCaptionPresets() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (presets: Record<string, string[]>) =>
      api.put<{ ok: boolean }>('/poster/caption-presets', { presets }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['caption-presets'] }),
  })
}
